import { usePortfolioSize } from "./PortfolioSizeContext";
import { PortfolioSizeControls } from "./PortfolioSizeControls";
import PortfolioSizeDisplay from "./PortfolioSizeDisplay";
import PortfolioSizeInput from "./PortfolioSizeInput";
import PortfolioSizeSlider from "./PortfolioSizeSlider";

const PortfolioSizeContainer = () => {
  const { portfolioSize, inputValue } = usePortfolioSize();
  const { 
    handleSliderChange, 
    handleInputChange, 
    handleInputBlur,
    MAX_PORTFOLIO_SIZE,
    MIN_PORTFOLIO_SIZE 
  } = PortfolioSizeControls();

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <PortfolioSizeDisplay portfolioSize={portfolioSize} />
        <PortfolioSizeInput
          inputValue={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
        />
      </div>

      <PortfolioSizeSlider
        value={portfolioSize}
        min={MIN_PORTFOLIO_SIZE}
        max={MAX_PORTFOLIO_SIZE}
        onChange={handleSliderChange}
      />
    </div>
  );
};

export default PortfolioSizeContainer;